import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import type { Plan } from "@circle-react/types";
import { forwardRef } from "react";

import { t } from "@/i18n-js/instance";

import { SubmitButton } from "../../../RegularPlan/SubmitButton";
import { BillingIntervalRadio } from "../BillingIntervalSelector/BillingIntervalRadio";
import { PlanPrice } from "../PlanInfo/PlanPrice";
import { PlanSavings } from "../PlanInfo/PlanSavings";
import { PlanTitle } from "../PlanInfo/PlanTitle";
import { PlanSummarySkeleton } from "../PlanSummarySkeleton";

interface ExpandedCheckoutViewProps {
  onCollapse: () => void;
  selectedPlan: Plan;
}

export const ExpandedCheckoutView = forwardRef<
  HTMLDivElement,
  ExpandedCheckoutViewProps
>(({ onCollapse, selectedPlan }, ref) => {
  if (!selectedPlan) {
    return <PlanSummarySkeleton />;
  }
  return (
    <div
      ref={ref}
      className="bg-primary absolute inset-x-0 bottom-0 flex max-h-[80vh] flex-col gap-y-5 overflow-y-auto rounded-t-xl p-5"
    >
      <div className="flex justify-between">
        <Typography.LabelLg weight="semibold">
          {t("pricing_plans.plan_settings.mobile_checkout_overlay.summary")}
        </Typography.LabelLg>
        <button type="button" onClick={onCollapse}>
          <Icon type="20-close" size={20} />
        </button>
      </div>
      <BillingIntervalRadio />
      <div>
        <PlanTitle />
        <PlanPrice />
      </div>
      <PlanSavings />
      <SubmitButton plan={selectedPlan} />
    </div>
  );
});

ExpandedCheckoutView.displayName = "ExpandedCheckoutView";
